import { type FC } from "react";
import { Button, ButtonType } from "syngenta-digital-cropwise-react-ui-kit";
import { type Props } from "../types";
import "./secondaryButton.less";

export const SecondaryButton: FC<Props> = ({ children }) => {
  return <Button type={ButtonType.default}>{children}</Button>;
};
